module.exports = __webpack_public_path__ + "img/flag.373d45df.png";